// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2JMIf","productName":"Table_productName__3Iged"};